import React, { useState } from 'react';
import {
  EnvelopeIcon,
  LockClosedIcon,
  EyeIcon,
  EyeSlashIcon,
} from '@heroicons/react/24/outline';
import { TWInput } from '../../../components/ui';

const Account = ({ email, onChange, password, terms, errors }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (value, key) => {
    onChange(value, key);
  };

  const emailError = errors.email ? 'Enter a valid email address' : undefined;
  const passwordError = errors.password
    ? 'Enter your password'
    : errors.passwordlength
    ? 'Password must be at least 8 characters'
    : undefined;

  return (
    <div className="grid grid-cols-1 gap-3 sm:gap-5">
      <TWInput
        label="Work email"
        labelIcon={EnvelopeIcon}
        type="email"
        autoComplete="email"
        size="lg"
        required
        placeholder="you@restaurant.com"
        value={email}
        onChange={(e) => handleChange(e.target.value, 'email')}
        error={emailError}
      />

      <div className="relative">
        <TWInput
          label="Password"
          labelIcon={LockClosedIcon}
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          size="lg"
          required
          placeholder="Minimum 8 characters"
          value={password}
          onChange={(e) => handleChange(e.target.value, 'password')}
          error={passwordError}
          hint={!passwordError ? 'At least 8 characters.' : undefined}
        />
        <button
          type="button"
          onClick={() => setShowPassword((s) => !s)}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          className="absolute right-3 top-[2.1rem] flex h-6 w-6 items-center justify-center text-slate-400 transition hover:text-slate-600 dark:hover:text-slate-200"
        >
          {showPassword ? (
            <EyeSlashIcon className="h-4 w-4" />
          ) : (
            <EyeIcon className="h-4 w-4" />
          )}
        </button>
      </div>

      <label
        htmlFor="terms"
        className="group mt-1 flex cursor-pointer items-start gap-3 rounded-lg border border-slate-200 bg-slate-50 p-3 transition hover:border-slate-300 hover:bg-white dark:border-slate-700 dark:bg-slate-800/60 dark:hover:border-slate-600 dark:hover:bg-slate-800"
      >
        <input
          id="terms"
          name="terms"
          type="checkbox"
          checked={terms}
          onChange={() => handleChange(!terms, 'terms')}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-blue-600 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-900"
        />
        <span className="text-xs leading-relaxed text-slate-600 dark:text-slate-300">
          I agree to thisway’s{' '}
          <a
            className="font-semibold text-blue-600 underline-offset-2 hover:underline dark:text-sky-400"
            href="https://www.thisway.co/terms"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            className="font-semibold text-blue-600 underline-offset-2 hover:underline dark:text-sky-400"
            href="https://www.thisway.co/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          .
        </span>
      </label>
      {errors.terms && (
        <p className="-mt-3 text-xs text-rose-600 dark:text-rose-400">
          Please accept the terms and conditions to continue.
        </p>
      )}
    </div>
  );
};

export default Account;
